import Header from '@components/layout/Header'
import {
	GREY_COLORS,
	WHITE
} from '@config/theme/colors'
import {
	Stack,
	styled
} from '@mui/material'
import { useAnalyticsApi } from '@services/api/analytics.api'
import { useAuth } from '@services/contexts/AuthContext'
import { CertificationProvider } from '@services/contexts/CertificationContext'
import { useSnackbar } from '@services/contexts/SnackbarContext'
import { TraineeListFiltersProvider } from '@services/contexts/TraineeListFiltersContext'
import { useMutation } from '@tanstack/react-query'
import React, {
	useEffect,
	useRef
} from 'react'
import { Outlet } from 'react-router-dom'

/**
 * Page container
 * @constructor
 */
const PageContainer = () => {
	const { increaseVisits } = useAnalyticsApi()
	const { addErrorSnackbar } = useSnackbar()
	const { token } = useAuth()
	const hasCalled = useRef(false)

	const { mutate: increaseVisitsMutate } = useMutation({
		mutationKey: ['increaseVisits'],
		mutationFn: increaseVisits,
		onError: addErrorSnackbar
	})

	useEffect(() => {
		// Avoid development context multiple calls
		if (token && !hasCalled.current) {
			increaseVisitsMutate()
			hasCalled.current = true
		}
	}, [token])

	return (
		<TraineeListFiltersProvider>
			<CertificationProvider>
				<Container>
					<Header />
					<Content>
						<Outlet />
					</Content>
				</Container>
			</CertificationProvider>
		</TraineeListFiltersProvider>
	)
}

const Container = styled(Stack)({
	backgroundColor: GREY_COLORS[50],
	flex: 1,
	minHeight: 0
})

const Content = styled(Stack)({
	backgroundColor: WHITE,
	borderRadius: '24px',
	flex: 1,
	margin: '0 16px 16px',
	minHeight: 0,
	padding: '20px'
})

export default PageContainer
